class Header {
  init() {
    this.accordions = document.querySelectorAll("[js-accordion]");

    this.accordion();
  }

  accordion() {
    if (this.accordions.length) {
      this.accordions.forEach((accordion) => {
        accordion.addEventListener("click", () => {
          accordion.closest(".accordion").classList.toggle("is-active");
        });
      });
    }
  }
}

export default Header;



// WEBPACK FOOTER //
// ./scripts/Accordion.js